import { useEffect, useState } from "react";
// components
import PageLayout from "../../components/PageLayout"
import EditSerieForm from "../../components/EditSerieForm";

// icons
import IconComponent from "../../components/Icon";
import { FaPencil } from "react-icons/fa6";
import { PiBooks } from "react-icons/pi";

// services
import axiosInstance from "../../api/apiClient";
import AddSerieForm from "../../components/AddSerieForm";


const Serie = () => {
    const [type, setType] = useState('');
    const [allSeries, setAllSeries] = useState([]);
    const [allAuthors, setAllAuthors] = useState([]);
    const [allBooks, setAllBooks] = useState([]);

    const handleDone = () => {
        setType('');
        getAllSeries();
    }

    const showCorrectForm = () => {
        switch (type) {
            case 'edit':
                return <EditSerieForm allSeries={allSeries} allAuthors={allAuthors} allBooks={allBooks} handleDone={handleDone} />
            case 'add':
                return <AddSerieForm allAuthors={allAuthors} allBooks={allBooks}/>
            default:
                return <></>
        }
    }

    const getAllSeries = async () => {
        await axiosInstance.get('/getAllSeries').then((data) => {
            setAllSeries(data);
        }).catch((error) => {
            console.error(error);
        });
    };

    const getAllAuthors = async () => {
        await axiosInstance.get('/getAllAuthors').then((data) => {
            setAllAuthors(data);
        }).catch((error) => {
            console.error(error);
        });
    };

    const getAllBooks = async () => {
        await axiosInstance.get('/getAllBooks').then((data) => {
            setAllBooks(data);
        }).catch((error) => {
            console.error(error);
        });
    };

    useEffect(() => {
        getAllSeries();
        getAllAuthors();
        getAllBooks();
    }, [])
   
    return (
        <PageLayout
            headerText="Series"
            type="gear"
        >
             <div className="grid md:grid-cols-2 grid-cols-1 gap-x-[40px] mt-[40px] cursor-pointer">
                <div className={`bg-white hover:bg-[#F7F7F7] rounded-3xl shadow-lg p-4 min-h-20 md:mt-0 mt-[40px] ${type === 'edit' ? 'border-2 border-[#60637A]' : ''}`} onClick={() => setType('edit')}>
                    <div className="flex justify-between items-center h-full">
                        <h1 className="text-2xl font-bold mb-0 text-[#60637A]">
                            Edit existing series
                        </h1>
                        <IconComponent className="size-12 rotate-[-20deg] opacity-45" color="#BBCFD8" icon={FaPencil} />
                    </div>

                </div>
                <div className={`bg-white hover:bg-[#F7F7F7] rounded-3xl shadow-lg p-4 min-h-20 md:mt-0 mt-[40px] ${type === 'add' ? 'border-2 border-[#60637A]' : ''}`}  onClick={() => setType('add')}>
                    <div className="flex justify-between items-center h-full">
                    <h1 className="text-2xl font-bold mb-0 text-[#60637A]">
                        Add serie
                    </h1>
                    <IconComponent className="size-16  opacity-45" color="#BBCFD8" icon={PiBooks} />
                </div>
                </div>
            </div>
            {showCorrectForm()}
        </PageLayout>
    )
    
}

export default Serie